/** Align with Kitchen-FrontEnd-UI Signup + atomic InputBox / SelectBox tokens */
export const COLORS = {
  ink: '#3F3F6E',
  accentLink: '#3F3F6E',
  accentOrange: '#FF7B29',
  labelFocusOrange: '#FF7A28',
  muted: '#6B7280',
  border: '#D7E0F2',
  rowDivider: '#E8EBEF',
  headerBg: '#F8F9FB',
  pageBg: '#FFFBF2',
  white: '#FFFFFF',
};

export const STATUS_FILTER_ALL = 'all';
export const STORE_VISIBILITY_FILTER_ALL = 'all';
export const STATUS_OPTIONS = [STATUS_FILTER_ALL, 'Active', 'Inactive'];
/** Account status values for the update-status modal (no “all”). */
export const ACCOUNT_STATUS_OPTIONS = ['Active', 'Inactive'];

/** Wait this long after the last keystroke before store name search updates the list (API + cache). */
export const STORE_SEARCH_DEBOUNCE_MS = 700;

// ── Style constants ───────────────────────────────────────────────────────────

export const outlinedSearchSx = {
  '& .MuiInputLabel-root': {
    color: COLORS.ink,
    fontSize: '13px',
    fontWeight: 500,
    fontFamily: 'Inter Regular, sans-serif',
  },
  '& .MuiInputLabel-root.Mui-focused': {
    color: COLORS.ink,
  },
  '& .MuiInputLabel-root.MuiInputLabel-shrink': {
    color: COLORS.ink,
    fontWeight: 500,
    paddingLeft: '4px',
  },
  '& .MuiOutlinedInput-root': {
    height: '42px',
    borderRadius: '5px',
    bgcolor: COLORS.white,
    fontFamily: 'Inter Regular, sans-serif',
    fontSize: 13,
    transition: 'all 0.2s ease',
    '& fieldset': { borderColor: COLORS.border, borderWidth: '1px' },
    '&:hover fieldset': { borderColor: COLORS.ink },
    '&.Mui-focused fieldset': { borderColor: COLORS.ink, borderWidth: '1px' },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: `${COLORS.ink} !important`,
    },
    '& input': {
      fontSize: '13px',
    },
  },
};

export const headerCellSx = {
  fontFamily: 'Inter Bold, sans-serif',
  fontSize: 11,
  fontWeight: 700,
  letterSpacing: '0.06em',
  textTransform: 'uppercase',
  color: COLORS.muted,
  bgcolor: COLORS.headerBg,
  borderTop: 'none',
  borderLeft: 'none',
  borderRight: 'none',
  borderBottom: `2px solid ${COLORS.border}`,
  py: 1.5,
  px: 2.5,
  whiteSpace: 'nowrap',
};

export const bodyCellSx = {
  borderTop: 'none',
  borderLeft: 'none',
  borderRight: 'none',
  borderBottom: `1px solid ${COLORS.rowDivider}`,
  py: 1.75,
  px: 2.5,
  verticalAlign: 'middle',
  fontFamily: 'Inter Regular, sans-serif',
  fontSize: 14,
  color: COLORS.ink,
};
